(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/category/page.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/category/page.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useContext = _React.useContext,
  useMemo = _React.useMemo;
const Icon = svs.ui.ReactIcon;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useParams = _ReactRouterDOM.useParams;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const _svs$eInstant$constan = svs.eInstant.constants,
  _svs$eInstant$constan2 = _svs$eInstant$constan.ROUTES,
  LOBBY = _svs$eInstant$constan2.LOBBY,
  CATEGORY = _svs$eInstant$constan2.CATEGORY,
  getSortOptionById = _svs$eInstant$constan.getSortOptionById;
const GameGrid = svs.eInstant.shared.GameGrid;
const ScrollToTop = svs.eInstant.components.ScrollToTop;
const Category = () => {
  var _getSortOptionById;
  const _svs$eInstant$shared$ = svs.eInstant.shared.components,
    InfoOverlay = _svs$eInstant$shared$.InfoOverlay,
    Background = _svs$eInstant$shared$.Background,
    SortGames = _svs$eInstant$shared$.SortGames;
  const history = useHistory();
  const _useParams = useParams(),
    categoryId = _useParams.categoryId;
  const _useContext = useContext(svs.eInstant.store.RouterContext),
    _useContext$state = _useContext.state,
    gameUrl = _useContext$state.gameUrl,
    categories = _useContext$state.categories;
  const category = categories.find(cat => cat.urlPath === categoryId) || {
    games: []
  };
  const featuredGame = category === null || category === void 0 ? void 0 : category.featuredGame;
  const _svs$eInstant$shared$2 = svs.eInstant.shared.hooks.useMetaTags({
      category
    }),
    update = _svs$eInstant$shared$2.update;
  const _svs$eInstant$shared$3 = svs.eInstant.shared.hooks.useLocalStorage(category === null || category === void 0 ? void 0 : category.urlPath, 'tickets-einstant-sort-games', null, 60),
    _svs$eInstant$shared$4 = _slicedToArray(_svs$eInstant$shared$3, 2),
    selected = _svs$eInstant$shared$4[0],
    setSelected = _svs$eInstant$shared$4[1];
  const sortFn = (_getSortOptionById = getSortOptionById(selected)) === null || _getSortOptionById === void 0 ? void 0 : _getSortOptionById.sortFn;
  const sortedGames = useMemo(() => sortFn(category.games || []), [sortFn, category.games]);
  const FeaturedGame = svs.eInstant.lobby.category.components.FeaturedGame;
  useEffect(() => {
    !gameUrl && update(CATEGORY);
  }, [category, gameUrl]);
  useEffect(() => {
    if (!category || !(category.games || []).length) {
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: 'Kunde inte hämta kategori',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: 'Försök igen senare eller kontakta kundservice.'
        }],
        actions: [{
          title: 'Okej',
          callback: () => {
            dialog.close();
            history.push(LOBBY);
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
  }, [category, history, LOBBY]);
  if (!category || !sortedGames.length) {
    return React.createElement(Background, {
      classNames: "tickets-einstant-background-category"
    });
  }
  return React.createElement(Background, {
    classNames: "tickets-einstant-background-category"
  }, React.createElement(InfoOverlay, {
    onCloseUrl: "".concat(svs.core.data.baseUrl).concat(CATEGORY.replace(':categoryId', category.urlPath))
  }), React.createElement(ScrollToTop, null), featuredGame && React.createElement("div", {
    className: "tickets-einstant-special-width-header"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-top-3 margin-h-1"
  }, React.createElement("div", {
    className: "f-body u-flex u-flex-row u-flex-align-items-center margin-bottom-2"
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700 margin-right-half",
    icon: category.icon,
    size: 500
  }), React.createElement("h1", {
    className: "h1 fc-fler-lotter-new-700 margin-0"
  }, category.title)))), React.createElement(FeaturedGame, {
    featuredGame: featuredGame
  }), React.createElement("div", {
    className: "tickets-einstant-max-width w100"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-v-2 margin-h-1"
  }, React.createElement(GridRow, {
    className: "u-flex u-flex-align-items-center",
    gutter: "0"
  }, !featuredGame && React.createElement(GridCol, {
    am: 8,
    lg: 10,
    md: 8,
    xs: 12
  }, React.createElement("div", {
    className: "tickets-einstant-special-width-header"
  }, React.createElement("div", {
    className: "u-flex u-flex-column margin-top-1"
  }, React.createElement("div", {
    className: "f-body u-flex u-flex-row u-flex-align-items-center margin-bottom-2"
  }, React.createElement(Icon, {
    color: "fc-fler-lotter-new-700 margin-right-half",
    icon: category.icon,
    size: 500
  }), React.createElement("h1", {
    className: "h1 fc-fler-lotter-new-700 margin-0"
  }, category.title))))), React.createElement(GridCol, {
    am: 4,
    className: "tickets-einstant-margin-left-auto",
    lg: 2,
    md: 4,
    xs: 12
  }, React.createElement(SortGames, {
    key: category.urlPath,
    selected: selected,
    setSelected: setSelected
  }))), React.createElement("div", {
    className: "margin-top-1-half"
  }, React.createElement(GameGrid, {
    games: sortedGames
  })))));
};
setGlobal('svs.eInstant.lobby.Category', Category);

 })(window);